import * as React from 'react';
import { Box } from '../../../Box/Box.js';
import { ImageAsset } from '../ImageAsset/ImageAsset.js';
import { SubtitleElement } from '../SubtitleElement/SubtitleElement.js';
import { TitleElement } from '../TitleElement/TitleElement.js';
import { useContentSlotListItem } from './useContentSlotListItem.js';

var ContainerBox = Box;
var ContentContainerBox = Box;
var ElementView = function ElementView(props) {
  var _useContentSlotListIt = useContentSlotListItem(props),
    isSelected = _useContentSlotListIt.isSelected,
    isCustomSlot = _useContentSlotListIt.isCustomSlot,
    checkmarkIconAssetId = _useContentSlotListIt.checkmarkIconAssetId,
    role = _useContentSlotListIt.role,
    title = _useContentSlotListIt.title,
    subTitle = _useContentSlotListIt.subTitle,
    leadingAsset = _useContentSlotListIt.leadingAsset,
    trailingAsset = _useContentSlotListIt.trailingAsset,
    leadingSlot = _useContentSlotListIt.leadingSlot,
    contentSlot = _useContentSlotListIt.contentSlot,
    trailingSlot = _useContentSlotListIt.trailingSlot,
    disabled = _useContentSlotListIt.disabled,
    display = _useContentSlotListIt.display,
    alignItems = _useContentSlotListIt.alignItems,
    textColor = _useContentSlotListIt.textColor,
    gap = _useContentSlotListIt.gap;
  return isCustomSlot ? /*#__PURE__*/React.createElement(ContainerBox, {
    disabled: disabled,
    display: display,
    alignItems: alignItems,
    gap: gap,
    textColor: textColor,
    role: role,
    "aria-checked": isSelected
  }, isSelected !== undefined ? /*#__PURE__*/React.createElement(ImageAsset, {
    asset: checkmarkIconAssetId,
    disabled: disabled,
    textColor: textColor,
    opacity: isSelected ? 1 : 0
  }) : null, leadingSlot, /*#__PURE__*/React.createElement(ContentContainerBox, {
    flexGrow: 1,
    textColor: undefined
  }, contentSlot), trailingSlot) : /*#__PURE__*/React.createElement(ContainerBox, {
    disabled: disabled,
    display: display,
    alignItems: alignItems,
    gap: gap,
    role: role,
    "aria-checked": isSelected
  }, isSelected !== undefined ? /*#__PURE__*/React.createElement(ImageAsset, {
    asset: checkmarkIconAssetId,
    disabled: disabled,
    textColor: textColor,
    opacity: isSelected ? 1 : 0
  }) : null, leadingAsset && /*#__PURE__*/React.createElement(ImageAsset, {
    asset: leadingAsset,
    disabled: disabled,
    textColor: textColor
  }), /*#__PURE__*/React.createElement(ContentContainerBox, {
    display: "flex",
    flexDirection: "column",
    gap: "4",
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(TitleElement, {
    title: title,
    textColor: textColor
  }), /*#__PURE__*/React.createElement(SubtitleElement, {
    title: subTitle,
    disabled: disabled
  })), trailingAsset && /*#__PURE__*/React.createElement(ImageAsset, {
    asset: trailingAsset,
    disabled: disabled,
    textColor: textColor
  }));
};
var ContentSlotListItem = /*#__PURE__*/React.memo(ElementView);

export { ContentSlotListItem };
//# sourceMappingURL=ContentSlotListItem.js.map
